import React, { useRef, useEffect, useState } from 'react';
import { Skeleton, useTheme, Box } from '@mui/material';

type LoadingSkeletonProps = {
  theme?: 'light' | 'dark';
  loaderWidth?: number | string;
  loaderHeight?: number | string;
  minWidth?: number | string;
  baseColor?: string;
  highlightColor?: string;
  style?: React.CSSProperties;
};

const LoadingSkeleton = ({
  theme,
  loaderWidth,
  loaderHeight,
  minWidth,
  baseColor,
  highlightColor,
  style,
}: LoadingSkeletonProps) => {
  const muiTheme = useTheme();
  const mode = theme ?? muiTheme.palette.mode;
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [isInline, setIsInline] = useState(false);

  useEffect(() => {
    if (wrapperRef.current) {
      const parent = wrapperRef.current.parentElement!;
      const parentStyle = window.getComputedStyle(parent);

      setIsInline(
        parentStyle.display === 'inline' ||
          parentStyle.display === 'inline-block' ||
          parentStyle.display === 'inline-flex'
      );
    }
  }, []);

  const finalWidth = loaderWidth ?? '100%';
  const finalHeight = loaderHeight ?? 20;
  const finalMinWidth = minWidth ?? 0;

  const finalBaseColor = baseColor ?? (mode === 'light' ? '#e9ebea' : '#17457a');
  const finalHighlightColor = highlightColor ?? (mode === 'light' ? '#aaaaaa' : '#1a67a3');

  return (
    <Box
      ref={wrapperRef}
      display={isInline ? 'inline-block' : 'block'}
      minWidth={finalMinWidth}
      width={finalWidth}
      height={finalHeight}
      style={style}
    >
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height="100%"
        sx={{
          bgcolor: finalBaseColor,
          '&::after': {
            background: `linear-gradient(90deg, ${finalBaseColor}, ${finalHighlightColor}, ${finalBaseColor})`,
          },
        }}
      />
    </Box>
  );
};

export default LoadingSkeleton;
